// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__zC4g8","buttons":"PendingPaymentAlert_buttons__3ShJW"};